<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-add-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <!-- <vs-input class="w-full mt-4" label="Username"  v-validate="'required|alpha_num'" name="username" />
        <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span> -->

        <vs-input class="w-full mt-4" :value="this.$store.state.userManagement.userAddObject.name" v-validate="'required|alpha_spaces|min:3'" data-vv-delay="100" name="name"  :label="$t('USER.name')" @input="setName" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" :value="this.$store.state.userManagement.userAddObject.email" :label="$t('USER.email')" @input="setEmail" type="email" v-validate="'required|email'" data-vv-delay="100" name="email" />
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <div class="mt-4">
            <label class="text-sm">{{ $t('USER.Languages') }}</label>
            <v-select
            label="name"
            multiple
            :closeOnSelect="true"
            :options="langOptions"
            @input="setLanguages"
            v-validate="'required'"
            name="languages"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
             />
            <span class="text-danger text-sm"  v-show="errors.has('languages')">{{ errors.first('languages') }}</span>
        </div>

      </div>

      <div class="vx-col md:w-1/2 w-full">

        <div class="mt-4">
          <label class="vs-input--label">{{ $t('USER.role') }}</label>
          <v-select @input="setRole" label="name" :clearable="false" :options="roleOptions" v-validate="'required'" name="role" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('role')">{{ errors.first('role') }}</span>
        </div>

        <div class="vs-component vs-con-input-label vs-input w-full mt-4 vs-input-primary">
          <label for="" class="vs-input--label">{{ $t('USER.Phone') }}</label>
          <div class="vs-con-input"><the-mask type="text" name="mobile" :value="this.$store.state.userManagement.userAddObject.mobile" @input="setMobile" :mask="['+55 (##) ####-####', '+55 (##) #####-####']" class="vs-inputx vs-input--input normal hasValue" style="border: 1px solid rgba(0, 0, 0, 0.2);"/></div>
          <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
        </div>

        <ul class="con-s w-full mt-4">
          <li>
            <label class="vs-input--label">Admin ?</label>
            <vs-switch v-model="isAdmin" @input="setIsAdmin" class="mt-2" />
          </li>
          <li class="mt-4">
            <label class="vs-input--label">{{ $t('USER.externalUser') }}</label>
            <vs-switch v-model="isExternalUser" @input="setIsExternalUser" class="mt-2" />
          </li>
        </ul>

      </div>

    </div>

    <div class="vx-row" v-if="customFields.length > 0">

      <div class="vx-col md:w-1/2 w-full" v-for="(field, index) in customFields" :key="index">
        <div v-if="field.type === 'select'" class="mt-4">
          <label class="text-sm">{{ field.label }}</label>
          <v-select
            :options="field.options"
            label="label"
            :clearable="true"
            append-to-body
            v-model="customFieldsModel[field.name]"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div v-else-if="field.type === 'select_multiple'" class="mt-4">
          <label class="text-sm">{{ field.label }}</label>
          <v-select
            :options="field.options"
            label="label"
            multiple
            append-to-body
            v-model="customFieldsModel[field.name]"
            :closeOnSelect="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{ $t('USER.EDIT.save_changes') }}</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/users')">{{ $t('USER.EDIT.cancel') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {
  performFetch,
  getUserCustomFields,
  validateUserCustomField,
  initUserCustomFieldModel,
  buildUserCustomDataForSave
} from '../../../helpers'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      roleOption: 0,
      isAdmin: false,
      isExternalUser: false,
      roleOptions: [],
      langOptions: [],
      allLanguageOptions: [],
      mobile: '',
      selectedRole: {},
      delegatorUrl: '',
      customFields: [],
      customFieldsModel: {}
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
    // selectedRole: {
    //   set(obj) {
    //     this.selectedRole = obj
    //   },
    //   get() {
    //     this.selectedRole = obj
    //   }
    // }
  },
  async created () {

    this.roleOptions = this.$store.state.userManagement.rolesList
    this.langOptions = this.$store.state.auth.languages
    this.allLanguageOptions = this.$store.state.auth.languages
    this.$store.commit('userManagement/setUserAddName', '')
    this.$store.commit('userManagement/setUserAddRole', '')
    this.$store.commit('userManagement/setUserAddRoleObject', {})
    this.$store.commit('userManagement/setUserAddEmail', '')
    this.$store.commit('userManagement/setUserAddUsername', '')
    this.$store.commit('userManagement/setUserAddMobile', '')
    this.$store.commit('userManagement/setUserAddLanguages', '')
    this.$store.commit('userManagement/setUserAddIsAdmin', false)
    this.$store.commit('userManagement/setUserAddExternalUser', false)

    this.$vs.loading({
      type: 'default'
    })

    // await fetch(this.$store.state.auth.api_url, {
    //   method: 'POST', headers: {"Content-Type": "application/json"},
    //   body: JSON.stringify({
    //     command: 'get_application_user_parameters',
    //     parameters: {
    //       application_token: this.$store.state.auth.app_token,
    //       session_token: this.$store.state.auth.token
    //     }
    //   })
    // })
    await performFetch(this.$store.state.auth.api_url, {
      command: 'get_application_user_parameters',
      parameters: {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token
      }
    })
      .then(async (response) => {
        if (response.status === 200) {
          await response.json().then(async (response) => {
            this.delegatorUrl = response.parameters.delegator_url
            setTimeout(() => {
              this.roleOptions = response.parameters.roles
              this.$vs.loading.close()
            }, 300)
          })
        } else if (response.status === 401) {
          setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
          this.$store.dispatch('auth/signOut')
        }
      })
      .catch(() => {
        this.$vs.notify({
          title: 'Atenção!',
          text: 'Não foi possível carregar os parâmetros da tela',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        this.$vs.loading.close()
      })

    await this.getCustomFields()
  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component has changed,
    // but this component is reused in the new route.
    // For example, for a route with dynamic params /foo/:id, when we
    // navigate between /foo/1 and /foo/2, the same Foo component instance
    // will be reused, and this hook will be called when that happens.
    // has access to >this component instance.
    const teste = false
    if (teste) {
      next()
    } else if (confirm('save Project?')) {
      next()
    } else {
      next(false)
    }
  },
  methods: {
    async getCustomFields() {
      this.$vs.loading({
        type: 'default'
      })

      if(this.delegatorUrl) {
        try{
          const response = await getUserCustomFields(this.delegatorUrl, this.$store.state.auth.app_token, this.$store.state.auth.token);
          if ('custom_fields' in response) {
            for (const field of response.custom_fields) {
              validateUserCustomField(field)

              this.customFields.push(field)
              this.$set(this.customFieldsModel, field.name, initUserCustomFieldModel(field))
            }
          }

        } catch(error) {
          console.error(`Erro ao capturar campos customizados: ${error}`)
        }
      }

      this.$vs.loading.close()
    },
    setName (e) {
      this.$store.commit('userManagement/setUserAddName', e)
    },
    setRole (value) {
      this.$store.commit('userManagement/setUserAddRole', value.hash)
      this.$store.commit('userManagement/setUserAddRoleObject', value)
    },
    setEmail (e) {
      this.$store.commit('userManagement/setUserAddEmail', e)
      this.$store.commit('userManagement/setUserAddUsername', e)
    },
    setMobile (e) {
      this.$store.commit('userManagement/setUserAddMobile', e)
    },
    setLanguages (e) {

      const selected_languages_id = []

      for (const item of e) {
        selected_languages_id.push(item.id)
      }

      this.langOptions = this.allLanguageOptions.filter(o => !selected_languages_id.includes(o.id))

      this.$store.commit('userManagement/setUserAddLanguages', e)
    },
    setIsAdmin (e) {
      this.$store.commit('userManagement/setUserAddIsAdmin', this.isAdmin)
    },
    setIsExternalUser () {
      this.$store.commit('userManagement/setUserAddExternalUser', this.isExternalUser)
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      if(!this.validateFields()) return

      this.$vs.loading({
        type: 'default'
      })

      fetch(this.$store.state.auth.api_url, {
        method: 'POST', headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'add_application_user',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user: {
              name: this.$store.state.userManagement.userAddObject.name,
              email: this.$store.state.userManagement.userAddObject.email,
              username: this.$store.state.userManagement.userAddObject.username,
              mobile: this.$store.state.userManagement.userAddObject.mobile,
              role: this.$store.state.userManagement.userAddObject.roleObject,
              languages: this.$store.state.userManagement.userAddObject.languages,
              is_admin: this.$store.state.userManagement.userAddObject.is_admin,
              external_user: this.$store.state.userManagement.userAddObject.external_user,
              custom_data: buildUserCustomDataForSave(this.customFields, this.customFieldsModel)
            }
          },
        })
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {
              if(response.message === 'Email Already Exists') {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Warning',
                  text: this.$t('USER.EmailAlreadyRegistered'),
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning'
                })
              } else {
                this.$store.state.userManagement.userAddObject.changes = true
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('USER.SuccessOperation'),
                  text: this.$t('USER.UserAdded'),
                  iconPack: 'feather',
                  icon: 'icon-check',
                  color: 'success'
                })

                this.$store.commit('userManagement/setUserAddName', '')
                this.$store.commit('userManagement/setUserAddRole', '')
                this.$store.commit('userManagement/setUserAddRoleObject', {})
                this.$store.commit('userManagement/setUserAddEmail', '')
                this.$store.commit('userManagement/setUserAddUsername', '')
                this.$store.commit('userManagement/setUserAddMobile', '')
                this.$store.commit('userManagement/setUserAddLanguages', '')
                this.$store.commit('userManagement/setUserAddIsAdmin', false)
                this.$store.commit('userManagement/setUserAddExternalUser', false)

                this.$router.push('/users')
              }
            })
          } else if (response.status == 400) {
            await response.json()
            .then(async (response) => {
              this.$vs.loading.close()
              if(response.message === 'Email Already Exists') {
                this.$vs.notify({
                  title: 'Warning!',
                  text: 'Este email já está registrado!',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning'
                })

                return
              }
            })
          } else if (response.status == 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada',
              text: 'Ocorreu um erro ao adicionar o usuário',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
              this.$store.commit('userManagement/setUserAddName', '')
              this.$store.commit('userManagement/setUserAddRole', '')
              this.$store.commit('userManagement/setUserAddRoleObject', {})
              this.$store.commit('userManagement/setUserAddEmail', '')
              this.$store.commit('userManagement/setUserAddUsername', '')
              this.$store.commit('userManagement/setUserAddMobile', '')
              this.$store.commit('userManagement/setUserAddLanguages', '')
              this.$store.commit('userManagement/setUserAddIsAdmin', false)
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER.operationNotPerformed'),
            text: 'An error occurred while registering the User',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$store.commit('userManagement/setUserAddName', '')
          this.$store.commit('userManagement/setUserAddRole', '')
          this.$store.commit('userManagement/setUserAddRoleObject', {})
          this.$store.commit('userManagement/setUserAddEmail', '')
          this.$store.commit('userManagement/setUserAddUsername', '')
          this.$store.commit('userManagement/setUserAddMobile', '')
          this.$store.commit('userManagement/setUserAddLanguages', '')
          this.$store.commit('userManagement/setUserAddIsAdmin', false)
        })

      /* eslint-enable */
    },
    validateFields () {
      if (this.$store.state.userManagement.userAddObject.name === '') {
        this.$vs.notify({
          title: 'Warning',
          text: this.$t('USER.fieldIsRequired', {field: this.$t('USER.Name')}),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }

      if (this.$store.state.userManagement.userAddObject.email === '') {
        this.$vs.notify({
          title: 'Warning',
          text: this.$t('USER.fieldIsRequired', {field: this.$t('USER.Email')}),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }

      if (this.$store.state.userManagement.userAddObject.role_hash === '') {
        this.$vs.notify({
          title: 'Warning',
          text: this.$t('USER.fieldIsRequired', {field: this.$t('USER.role')}),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }

      if (this.$store.state.userManagement.userAddObject.languages.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text:  this.$t('USER.fieldIsRequired', {field: this.$t('USER.Languages')}),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }

      return true
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  }
}
</script>
